import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, primaryEventsCount } = props;
  const primaryCount = primaryEventsCount || 0;
  const hasNoResult = listingsAreLoaded && totalItems === 0 && primaryCount === 0;
  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <FormattedMessage id="SearchPage.noResults" />
    </div>
  ) : null;
};

NoSearchResultsMaybe.defaultProps = {
  primaryEventsCount: 0,
};

export default NoSearchResultsMaybe;
